"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InputField;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputField = require("./InputField.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function InputField(_ref) {
  var children = _ref.children,
      dataAttr = _ref.dataAttr,
      disabled = _ref.disabled,
      error = _ref.error,
      focus = _ref.focus,
      password = _ref.password,
      success = _ref.success,
      value = _ref.value;
  return _react.default.createElement("div", _extends({
    className: (0, _InputField.mInputField)({
      password: password
    }).has({
      error: error,
      focus: focus,
      success: success,
      value: value
    }).is({
      disabled: disabled
    }).toString()
  }, dataAttr), children);
}

InputField.propTypes = {
  children: _propTypes.default.node,
  dataAttr: _propTypes.default.object,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.bool,
  focus: _propTypes.default.bool,
  success: _propTypes.default.bool,
  value: _propTypes.default.bool,
  password: _propTypes.default.bool
};
InputField.defaultProps = {
  children: null,
  dataAttr: {},
  disabled: false,
  error: false,
  focus: false,
  success: false,
  value: false,
  password: false
};